<template>
  <div class="assignmentdiv">
    <div v-if="!isButton" class="assignmentheader">{{ label }}</div>
    <div v-else class="assignmentbuttonheader">
      <div class="text-block-7">{{ label }}</div>
      <a @click.prevent.stop="handleAction" href="#" class="w-inline-block">
        <img src="images/play-button_1.png" alt />
      </a>
    </div>
    <div class="assignmentbody">
      <div class="assignmentcolumn">
        <div class="assignmentcolumnheader">Verfügbar</div>
        <div class="assignmentcolumnscrolldiv">
          <div class="assignmentcolumncontent">
            <div
              v-for="a of availableDiff"
              :key="a.id"
              class="assignmentcontenttext"
            >
              <click-highlight-span
                ref="label"
                @labelClicked="assignLabelClicked"
                @doubleClicked="obj => doubleClickEdit(obj, type)"
                :obj="a"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="assignmentbuttons">
        <a href="#" @click="shift(true)" class="arrowrightbutton w-button"></a>
        <a href="#" @click="shift(false)" class="arrowleftbutton w-button"></a>
      </div>
      <div class="assignmentcolumn">
        <div class="assignmentcolumnheader">Zugeordnet</div>
        <div class="assignmentcolumnscrolldiv">
          <div class="assignmentcolumncontent">
            <div
              v-for="a of assigned"
              :key="a.id"
              class="assignmentcontenttext"
              :style="subLabel ? 'margin: 2px auto; display: flex;' : ''"
            >
              <click-highlight-span
                :filterShow="filterShowAssigned"
                :filter="
                  filterShowMapping[a.id]
                    ? !!filterShowMapping[a.id].filter
                    : false
                "
                :show="
                  filterShowMapping[a.id]
                    ? !!filterShowMapping[a.id].show
                    : false
                "
                ref="label"
                @labelClicked="removeLabelClicked"
                @doubleClicked="obj => doubleClickEdit(obj, type)"
                @filterClicked="$emit('filterClicked', a)"
                @showClicked="$emit('showClicked', a)"
                :obj="a"
                :style="subLabel ? 'width: 100px;' : ''"
              />
              <!--<span v-if="subLabel">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
              <input v-if="subLabel" v-model="a.label" type="text" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ClickHighlightSpan from "./ClickAndHighlightableTextSpan";
import labeldoubleclicked from "@/components/mixins/labeldoubleclicked.mixin";
export default {
  mixins: [labeldoubleclicked],
  components: {
    ClickHighlightSpan
  },
  props: {
    available: {
      type: Array,
      required: true
    },
    assigned: {
      type: Array,
      required: true
    },
    filterShowAssigned: {
      type: Boolean,
      default() {
        return false;
      }
    },
    filterShowMapping: {
      type: Object,
      default() {
        return {};
      }
    },
    label: {
      type: String,
      required: true
    },
    isButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    type: {
      type: String,
      required: true
    },
    singleSelect: {
      type: Boolean,
      default() {
        return false;
      }
    },
    subLabel: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      assign: [],
      remove: [],
      selfAssigned: [],
      selfAvailable: [],
      lastClicked: {}
    };
  },
  computed: {
    availableDiff() {
      const assignedIds = this.assigned.map(a => a.id);
      return this.available.filter(a => !assignedIds.includes(a.id));
    }
  },
  methods: {
    assignLabelClicked(val) {
      this.assign = this.addOrRemoveToArray(this.assign, val);
      if (val.active) {
        if (this.singleSelect) {
          this.assign[0] = val.obj;
          this.assign.length = 1;
        }
        this.lastClicked = val.obj;
      } else {
        this.lastClicked = {};
      }
      this.$util.eventbus.$emit("labelClicked", this);
    },
    removeLabelClicked(val) {
      this.remove = this.addOrRemoveToArray(this.remove, val);
      if (val.active) {
        this.lastClicked = val.obj;
      } else {
        this.lastClicked = {};
      }
      this.$util.eventbus.$emit("labelClicked", this);
    },
    /**
     * fired wehen a label is clicked,
     * * array -> the array to remove or add the value
     * * val -> contains 2 members -> val.active (true/false), val.obj (Object)
     */
    addOrRemoveToArray(array, val) {
      if (val.active) {
        array.push(val.obj);
      } else {
        array = array.filter(e => e.id !== val.obj.id);
      }
      return array;
    },
    shift(assign = true) {
      if (assign) {
        this.selfAssigned = this.assigned.concat(this.assign);
        this.selfAvailable = this.available.filter(
          e => !this.assign.includes(e)
        );
      } else {
        this.selfAvailable = this.available.concat(this.remove);
        this.selfAssigned = this.assigned.filter(e => !this.remove.includes(e));
      }
      const event = {
        available: _.uniq(this.selfAvailable),
        assigned: _.uniq(this.selfAssigned),
        assign: _.uniq(Object.assign([], this.assign)),
        remove: _.uniq(Object.assign([], this.remove))
      };
      this.assign = [];
      this.remove = [];
      this.$emit("change", event);
    },
    handleAction(e) {
      e.entity = this.lastClicked;
      e.entity.type = this.overlayType;
      this.$emit("buttonClick", e);
    },
    handleLabelClickedEventAction(el) {
      if (el !== this) {
        if (this.$refs.label) {
          this.$refs.label.forEach(l => l.setLabelState(false));
        }
      }
    }
  },
  mounted() {
    this.selfAssigned = this.assigned;
    this.selfAvailable = this.available;
    this.$util.eventbus.$on("labelClicked", this.handleLabelClickedEventAction);
  },
  beforeDestroy() {
    this.$util.eventbus.$off(
      "labelClicked",
      this.handleLabelClickedEventAction
    );
  }
};
</script>
